<template>
  <v-container>
    <v-btn icon color="black" @click="goBack()">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-data-table
      :headers="headers"
      :items="preguntas"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Preguntas</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>

          <v-dialog v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                Nueva pregunta
              </v-btn>
            </template>

            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form ref="form" lazy-validation>
                    <v-row class="mb-2">
                      <v-col cols="12" sm="8" md="12">
                        <v-text-field
                          :rules="rules"
                          v-model="editedItem.pregunta"
                          label="Pregunta"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                      <!-- N PREGUNTA
                      <v-col cols="12" sm="4" md="5">
                        <v-text-field
                          :rules="rules"
                          v-model="editedItem.numero_pregunta"
                          label="Número de pregunta"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col> -->
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          :rules="rules"
                          v-model="editedItem.valor"
                          label="Valor"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                      <!-- respuesta  <v-col class="d-flex" cols="12" md="5" sm="6">
                        <v-select
                          v-model="autoevaluable"
                          :items="autoevaluables"
                          label="Autoevaluable"
                          item-text="tipo"
                          item-value="valor"
                          outlined
                          dense
                        ></v-select>
                      </v-col>-->
                    </v-row>
                    <v-row v-if="editedItem.idpregunta == 0">
                      <v-col cols="12" sm="12" md="12">Respuesta </v-col>
                      <!-- respuesta -->
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="respuesta.a"
                          label="Opción A"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="respuesta.b"
                          label="Opción B"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="8" md="12">
                        <v-text-field
                          v-model="respuesta.c"
                          label="Opción C"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="8" md="12">
                        <v-text-field
                          v-model="respuesta.d"
                          label="Opción D"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="8" md="12">
                        <v-select
                          v-model="respuesta.opcion_correcta"
                          :items="opciones"
                          label="Opción correcta"
                          item-text="tipo"
                          item-value="valor"
                          outlined
                          dense
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn color="blue darken-1" text @click="reset">
                  Limpiar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancelar
                </v-btn>
                <v-btn color="blue darken-1" text @click="save">
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >¿Estás seguro de eliminar este elemento?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancelar</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogMore" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Respuesta</v-card-title>
              <v-card-text>
                <v-container><OpcionMultiple /> </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeMore"
                  >Cancelar</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              icon
              @click="openMore(item)"
            >
              <v-icon small>
                mdi-plus-thick
              </v-icon>
            </v-btn>
          </template>
          <span>Ver respuesta</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              icon
              @click="editItem(item)"
            >
              <v-icon small>
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <span>Editar pregunta</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              icon
              @click="deleteItem(item)"
            >
              <v-icon small>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Eliminar pregunta</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Actualizar
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import OpcionMultiple from "./PreguntaMultiple.vue";
import { mapActions, mapGetters } from "vuex";

var moment = require("moment");
moment.locale();

export default {
  components: {
    OpcionMultiple,
  },
  data: () => ({
    rules: [(value) => !!value || "Campo obligatorio."],
    e6: 1,
    x: "",
    dialogMore: false,
    evaluacion: null,
    evaluaciones: [],
    tipo_pregunta: null,
    tipo_preguntas: [],
    autoevaluable: null,
    autoevaluables: [
      { tipo: "Sí", valor: 1 },
      { tipo: "No", valor: 0 },
    ],
    opciones: ["A", "B", "C", "D"],
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "Núm. ",
        align: "start",
        value: "numero_pregunta",
      },
      { text: "Pregunta", value: "pregunta" },
      { text: "Valor", value: "valor" },
      { text: "Evaluación", value: "idevaluacion" },
      { text: "Tipo pregunta", value: "idtipo_pregunta" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    preguntas: [], //arreglo
    editedIndex: -1,
    editedItem: {
      //agrego cada campo a utlizar
      idpregunta: 0,
      pregunta: "",
      numero_pregunta: 0,
      valor: 0,
      autoevaluable: 0,
      idevaluacion: 0,
      idtipo_pregunta: 0,
      usuario_registro: 0,
      fecha_creacion: null,
      fecha_actualizo: null,
      deleted: 0,
    },
    defaultItem: {
      idpregunta: 0,
      pregunta: "",
      numero_pregunta: 0,
      valor: 0,
      autoevaluable: 0,
      idevaluacion: 0,
      idtipo_pregunta: 0,
      usuario_registro: 0,
      fecha_creacion: null,
      fecha_actualizo: null,
      deleted: 0,
    },
    respuesta: {
      idpregunta_multiple: 0,
      a: "",
      b: "",
      c: "",
      d: "",
      opcion_correcta: "",
      idpregunta: 0,
      usuario_registro: 0,
      fecha_creacion: null,
      fecha_actualizo: null,
      deleted: 0,
    },
    numero_pregunta: 0,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva pregunta" : "Editar pregunta";
    },

    ...mapGetters("Evaluaciones", ["getIdEvaluacion"]),
    ...mapGetters("UsuarioCapa", ["getUsuarioCapa", "getLogeadoCapa"]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogMore(val) {
      val || this.closeMore();
    },
    getIdEvaluacion() {
      this.initialize();
    },
    respuesta() {
      console.log("respuesta");
      console.log(this.respuesta);
    },
  },

  created() {
    this.initialize();
    // Generando la fecha de hoy
    const fecha = new Date().toLocaleDateString("en-Es", {
      timeZone: "America/Mexico_City",
    });
    this.fecha = moment(fecha)
      .format()
      .substr(0, 10);
  },

  methods: {
    ...mapActions("Preguntas", ["guardarIdPregunta"]),

    initialize() {
      this.evaluaciones = [];
      this.$http
        .get("evaluaciones.all")
        .then((responseTipo) => {
          this.evaluaciones = responseTipo.body;
        })
        .catch((error) => {
          console.log(error);
        });

      this.$http
        .get("tipo_preguntas.all")
        .then((responseTipo) => {
          this.tipo_preguntas = responseTipo.body;
        })
        .catch((error) => {
          console.log(error);
        });

      this.$http
        .get("preguntas.all")
        .then((responsepreguntas) => {
          //   this.preguntas = responsepreguntas.body;
        })
        .catch((error) => {
          console.log(error);
        });
      this.$http
        .get("preguntas.evaluaciones.all/" + this.getIdEvaluacion)
        .then((responsepreguntas) => {
          this.preguntas = responsepreguntas.body;
          this.numero_pregunta = responsepreguntas.body.length;
          console.log(this.numero_pregunta);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goBack() {
      window.history.back();
    },
    editItem(item) {
      this.editedIndex = this.preguntas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.preguntas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.preguntas.splice(this.editedIndex, 1);
      //"Borrando"
      var datos = {
        pregunta: this.editedItem.pregunta,
        idcurso: this.editedItem.idcurso,
        usuario_registro: this.getUsuarioCapa.idusuario,
        fecha_creacion: this.editedItem.fecha_creacion,
        fecha_actualizo: this.fecha,
        deleted: 1,
      };

      this.$http
        .put("preguntas.update/" + this.editedItem.idpregunta, datos)
        .then((response) => {
          this.initialize();
        })
        .catch((error) => console.log(error));

      console.log(this.editedItem.idpregunta + " borrar");
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$refs.form.reset();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    openMore(item) {
      this.guardarIdPregunta(item.idpregunta);
      this.dialogMore = true;
    },
    closeMore() {
      this.dialogMore = false;
    },

    save() {
      //recibe los campos del form
      console.log("f o r m");

      console.log(this.editedItem);
      console.log(this.respuesta);

      //guardo en una variable los datos a guardar id = this.editedItem.idcurso;

      var datos = {
        pregunta: this.editedItem.pregunta,
        numero_pregunta:
          this.editedItem.numero_pregunta == 0
            ? this.numero_pregunta + 1
            : this.editedItem.numero_pregunta,
        valor: this.editedItem.valor,
        autoevaluable: 1, // por el momento todas son auto evaluables
        idevaluacion: this.getIdEvaluacion,
        idtipo_pregunta: 1,
        fecha_creacion:
          this.editedItem.fecha_creacion === null
            ? this.fecha
            : this.editedItem.fecha_creacion,
        fecha_actualizo: this.fecha,
        usuario_registro:
          this.editedItem.usuario_registro === 0
            ? this.getUsuarioCapa.idusuario
            : this.editedItem.usuario_registro,
        deleted: 0,
      };
      var d = {
        a: this.respuesta.a,
        b: this.respuesta.b,
        c: this.respuesta.c,
        d: this.respuesta.d,
        opcion_correcta: this.respuesta.opcion_correcta,
        idpregunta: 0,
        fecha_creacion: this.fecha,
        fecha_actualizo: this.fecha,
        usuario_registro: 1,
        deleted: 0,
      };
      if (this.editedIndex > -1) {
        this.$http
          .put("preguntas.update/" + this.editedItem.idpregunta, datos)
          .then((response) => {
            this.initialize();
          })
          .catch((error) => console.log(error));
        Object.assign(this.preguntas[this.editedIndex], this.editedItem);
      } else {
        this.$http
          .post("preguntas.add", datos)
          .then((response) => {
            this.initialize();

            d.idpregunta = response.body.id;

            this.$http
              .post("pregunta_multiple.add", d)
              .then((response) => {
                this.initialize();
              })
              .catch((error) => console.log(error));
          })
          .catch((error) => console.log(error));

        this.preguntas.push(this.editedItem);
      }
      this.close();
    },
    reset() {
      this.$refs.form.reset();
    },
  },
};
</script>
